import React from 'react';
import { FooterContainer, CopyrightText } from './styles';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <CopyrightText>
        © Copyright 2015-{currentYear <= 2025 ? 2025 : currentYear} - Mind Group
        LTDA
      </CopyrightText>
    </FooterContainer>
  );
};

export default Footer;
